<div class="radio-check">
  <rt-icon [name]="icon" size="small" layout layout-align-items-center layout-justify-center="">
  </rt-icon>
</div>
<div class="label">
  {{ item.option }}
</div>
